import { createContext, useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GetUserMenuItems } from "components/layouts/logic/GetUserMenuItems";
import { GetUserPermissions } from "components/layouts/logic/GetUserPermissions";

const PermissionsContext = createContext();

export const PermissionsProvider = ({ children }) => {
  const navigate = useNavigate();
  const [filteredItems, setFilteredItems] = useState([]);
  const [userPermissions, setUserPermissions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        
        const [menuItems, permissions] = await Promise.all([
          GetUserMenuItems(navigate),
          GetUserPermissions(navigate)
        ]);

        setFilteredItems(Array.isArray(menuItems) ? menuItems : []);
        setUserPermissions(Array.isArray(permissions) ? permissions : []);
      } catch (error) {
        console.error(error);
        setFilteredItems([]);
        setUserPermissions([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [navigate]);

  const value = {
    filteredItems,
    setFilteredItems,
    userPermissions,
    setUserPermissions,
    isLoading,
  };

  return (
    <PermissionsContext.Provider value={value}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionsContext);
